import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  const transformArgs = {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: params.dateHierarchy,
    group_by_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
  };

  return transformArgs;
};
